import axios from '../../../axios';
const url = '/invoicingservice/api';

export const getCurrencyList = () => axios.get(`${url}/client-currencies`);
